import React from 'react';
import { makeStyles } from "@mui/styles";
import { LinearProgress } from "@mui/material";

const TableWrapper: React.FC<TableWrapperProps> = (props) => {
    const styles = useStyles();

    return (
        <div className={ styles.root }>
            <div className={ styles.loaderTop }>
                {
                    props.isLoading &&
                    <LinearProgress />
                }
            </div>
            { props.children }
            <div className={ styles.loaderBottom }>
                {
                    props.isLoading &&
                    <LinearProgress />
                }
            </div>
        </div>
    );
}
export default TableWrapper;

const useStyles = makeStyles(theme => ({
    root: {
        position: 'relative',
        backgroundColor: "#ffffff",
    },
    loaderTop: {
        position: 'absolute',
        top: 0,
        width: '100%'
    },
    loaderBottom: {
        position: 'absolute',
        bottom: 0,
        width: '100%'
    }
}));

export interface TableWrapperProps {
    readonly isLoading?: boolean;
    readonly children?: React.ReactNode;
}